import { InfoPanel } from "@modules/info-panel/InfoPanel.ts"
import { Cookie } from "@modules/util/Cookie.ts"

const loginStatus = new Cookie(
    "loginSuccess",
    {
        path: "/",
        domain: SiteInfo.cookieDomain,
    },
    true,
)
const logoutStatus = new Cookie(
    "logoutSuccess",
    {
        path: "/",
        domain: SiteInfo.cookieDomain,
    },
    true,
)
let statusMessage = ""

if ("" !== loginStatus.value) {
    if (loginStatus.value) {
        statusMessage = "Du hast dich erfolgreich angemeldet"

        if (SiteInfo.membershipInfoMessage) {
            statusMessage +=
                '<span class="membership-info-message"><span class="membership-info-highlight">Hinweis:</span> ' +
                SiteInfo.membershipInfoMessage +
                "</span>"
        }
    } else {
        statusMessage = "Der Anmeldevorgang ist leider fehlgeschlagen"
    }

    loginStatus.removeCookie()
} else if ("" !== logoutStatus.value) {
    statusMessage = logoutStatus.value
        ? "Du hast dich erfolgreich abgemeldet"
        : "Beim Abmelden ist ein Fehler aufgetreten"

    logoutStatus.removeCookie()
}

if ("" !== statusMessage) {
    window.setTimeout(() => {
        InfoPanel.displayMessage(statusMessage)
    }, 10)
}
